import { render } from "./OnboardingPage.vue?vue&type=template&id=26853080"
const script = {}

import "./OnboardingPage.vue?vue&type=style&index=0&id=26853080&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__